<div class="contacts-container mt-4">
        <div class="d-grid contacts-header">
            <div class="d-flex align-items-center contact-title-wrapper">
                <img src="assets/svg/contract-icon.svg" width="20" class="contact-section-icon">
                <h3 class="text-semibold contact-title">Contratos</h3>
            </div>
            <div class="justify-self-end">
                <button class="action-btn primary" (click)="openMdlCreateContract()">
                    Crear nuevo contrato
                </button>
            </div>
        </div>
    <div class="header-stats mt-2">
      <span>{{contratos.length}} elementos | Se actualizó hace 2 minutos</span>
    </div>
    <div class="prospectos-table mt-4">
      <table>
        <thead>
          <tr>
            <th class="checkbox-column text-center">
              <img src="assets/svg/checkline-icon.svg" />
            </th>
            <th>Numero de contrato</th>
            <th>Monto</th>
            <th>Fecha expiración</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let p of contratos">
            <td class="checkbox-column">
              <input type="checkbox" (click)="$event.stopPropagation()" />
            </td>
            <td>{{ p.numero_contrato }}</td>
            <td>{{ p.monto || '-' }} {{p.moneda}}</td>
            <td>{{ p.fecha_expiracion }}</td>
            <div class="dropdown-container">
              <button class="dots-button">
                <svg class="dots-icon" viewBox="0 0 24 24">
                  <circle cx="12" cy="5" r="2" />
                  <circle cx="12" cy="12" r="2" />
                  <circle cx="12" cy="19" r="2" />
                </svg>
              </button>
              <div class="dropdown-menu">
                <button class="dropdown-item">Modificar</button>
                <button class="dropdown-item">Eliminar</button>
                <button class="dropdown-item">Cambiar propietario</button>
                <button class="dropdown-item">Modificar etiquetas</button>
              </div>
            </div>
          </tr>
        </tbody>
      </table>
    </div>
        <div class="contact-table-footer text-center">
      <button class="btn-primary-outline-2">Ver todos los contratos</button>
    </div>





    </div>

    <div class="contacts-container mt-4">
        <div class="d-grid contacts-header">
            <div class="d-flex align-items-center contact-title-wrapper">
                <img src="assets/svg/target-icon.svg" width="20" class="contact-section-icon">
                <h3 class="text-semibold contact-title">Historial de campañas</h3>
            </div>
            <div class="justify-self-end">
                <button class="action-btn primary" (click)="openModal()">
                    Agregar campaña
                </button>


            </div>
        </div>
    </div>

    